import { createContext, useContext } from 'react';
import { ContactType } from 'constants/contacts';

const ContactTypeContext = createContext<ContactType>(ContactType.Individual);

const useContactTypeContext = () => {
    return useContext(ContactTypeContext);
};

export { ContactTypeContext, useContactTypeContext };
